// extracted by mini-css-extract-plugin
export var textInput = "_dm-0";